import { gql } from "@apollo/client";

import { rolesFragment } from "../fragments";

export const getRoles = gql`
    ${rolesFragment}
    query getRoles {
        getMyLensesRoles {
            ...MyLensesRoles
        }
    }
`;
